import { render, staticRenderFns } from "./CmsAdsCategory.vue?vue&type=template&id=6ccde84a&scoped=true"
import script from "./CmsAdsCategory.vue?vue&type=script&lang=js"
export * from "./CmsAdsCategory.vue?vue&type=script&lang=js"
import style0 from "./CmsAdsCategory.vue?vue&type=style&index=0&id=6ccde84a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccde84a",
  null
  
)

export default component.exports